// src/data/catalogs.ts
export interface CatalogItem {
  id: string;
  title: string;
  description: string;
  pdfUrl: string;
  imageSrc: string;
  imageAlt: string;
  category: string;
  year: string;
}

export const catalogsData: CatalogItem[] = [
  {
    id: "cat-furniture",
    title: "Luxury Furniture Collection",
    description: "Premium handcrafted furniture for modern living spaces.",
    pdfUrl: "/pdfs/sample.pdf",
    imageSrc: "/images/catalog/copperv2.webp",
    imageAlt: "Minimalist living room leather sofa styling",
    category: "Furniture",
    year: "2024"
  },
  {
    id: "cat-decor",
    title: "Handcrafted Wall Decor",
    description: "Curated wall art and decorative pieces for elegant interiors.",
    pdfUrl: "/pdfs/decor-catalog.pdf",
    imageSrc: "/images/catalog/bathroomv2.webp",
    imageAlt: "Curated modern frame layouts",
    category: "Decor",
    year: "2024"
  },
  {
    id: "cat-foundry",
    title: "Master Foundry Artifacts",
    description: "Artisan crafted foundry pieces with timeless appeal.",
    pdfUrl: "/pdfs/foundry-catalog.pdf",
    imageSrc: "/images/catalog/kitchenv2.webp",
    imageAlt: "Artisan wooden shelving unit setup",
    category: "Artifacts",
    year: "2024"
  },
  {
    id: "cat-lighting",
    title: "Illumination & Metal Lamps",
    description: "Premium lighting solutions for sophisticated spaces.",
    pdfUrl: "/pdfs/sample.pdf",
    imageSrc: "/images/catalog/furniturev2.webp",
    imageAlt: "Premium hanging bronze light fixture cluster",
    category: "Lighting",
    year: "2024"
  },
  {
    id: "cat-outdoor",
    title: "Outdoor Living Collection",
    description: "Weather-resistant luxury pieces for outdoor elegance.",
    pdfUrl: "/pdfs/outdoor-catalog.pdf",
    imageSrc: "/images/catalog/home-decorv21.webp",
    imageAlt: "Luxury outdoor patio furniture arrangement",
    category: "Outdoor",
    year: "2024"
  },
  {
    id: "cat-bedroom",
    title: "Bedroom Sanctuary Series",
    description: "Transform your bedroom into a peaceful luxury retreat.",
    pdfUrl: "/pdfs/bedroom-catalog.pdf",
    imageSrc: "/images/catalog/bedroom.webp",
    imageAlt: "Elegant bedroom suite with custom headboard",
    category: "Bedroom",
    year: "2024"
  },
  {
    id: "cat-kitchen",
    title: "Kitchen & Dining Essentials",
    description: "Refined dining furniture and kitchen storage solutions.",
    pdfUrl: "/pdfs/kitchen-catalog.pdf",
    imageSrc: "/images/catalog/kitchen.webp",
    imageAlt: "Modern kitchen island with bar seating",
    category: "Kitchen",
    year: "2024"
  },
  {
    id: "cat-textiles",
    title: "Luxury Textile & Upholstery",
    description: "Fine fabrics and upholstery for bespoke furniture pieces.",
    pdfUrl: "/pdfs/textiles-catalog.pdf",
    imageSrc: "/images/catalog/textiles.webp",
    imageAlt: "Premium fabric swatches and upholstered chair",
    category: "Textiles",
    year: "2023"
  },
  {
    id: "cat-storage",
    title: "Smart Storage Solutions",
    description: "Elegant storage systems that blend function with style.",
    pdfUrl: "/pdfs/storage-catalog.pdf",
    imageSrc: "/images/catalog/storage.webp",
    imageAlt: "Custom built-in wardrobe and storage units",
    category: "Storage",
    year: "2023"
  },
  {
    id: "cat-art",
    title: "Sculptural Art Pieces",
    description: "Original sculptural works and limited edition art objects.",
    pdfUrl: "/pdfs/art-catalog.pdf",
    imageSrc: "/images/catalog/art.webp",
    imageAlt: "Bronze abstract sculpture on marble plinth",
    category: "Art",
    year: "2023"
  },
  {
    id: "cat-rugs",
    title: "Handwoven Rug Collection",
    description: "Artisan handwoven rugs from the finest natural fibers.",
    pdfUrl: "/pdfs/rugs-catalog.pdf",
    imageSrc: "/images/catalog/rugs.webp",
    imageAlt: "Persian style handwoven area rug detail",
    category: "Rugs",
    year: "2023"
  },
  {
    id: "cat-mirrors",
    title: "Statement Mirror Editions",
    description: "Architectural mirrors that define and elevate any space.",
    pdfUrl: "/pdfs/mirrors-catalog.pdf",
    imageSrc: "/images/catalog/home-decorv21.webp",
    imageAlt: "Oversized arch mirror in brushed gold frame",
    category: "Mirrors",
    year: "2023"
  }
];